import request from '../utils/request'

export async function putRequestStatus(requestId, status) {
  const response = await request({
    url: `/participation_requests/${requestId}`,
    method: 'PUT',
    data: {
      status,
    },
  })
  return response
}
